import { render, staticRenderFns } from "./manage-sub-menu.vue?vue&type=template&id=6e3d0ae6&scoped=true&"
import script from "./manage-sub-menu.vue?vue&type=script&lang=js&"
export * from "./manage-sub-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3d0ae6",
  null
  
)

export default component.exports